module.exports = __webpack_public_path__ + "img/1228852123.343239e1.jpg";